import { render } from "./Awards.vue?vue&type=template&id=1b323933&scoped=true"
import script from "./Awards.vue?vue&type=script&lang=js"
export * from "./Awards.vue?vue&type=script&lang=js"

import "./Awards.vue?vue&type=style&index=0&id=1b323933&lang=scss&scoped=true"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b323933"]])

export default __exports__